import { CreditCard, Loader2 } from 'lucide-react';
import { useState } from 'react';
import { billingApi } from '@/api/billing';
import { Button } from '@/components/ui/button';

interface ManageBillingButtonProps {
  mode: 'subscribe' | 'manage';
  className?: string;
}

export function ManageBillingButton({ mode, className }: ManageBillingButtonProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClick = async () => {
    setError(null);
    setIsLoading(true);

    try {
      const session =
        mode === 'subscribe'
          ? await billingApi.createCheckoutSession()
          : await billingApi.createPortalSession();

      window.location.href = session.url;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Unable to redirect to Stripe';
      setError(message);
      setIsLoading(false);
    }
  };

  const label = mode === 'subscribe' ? 'Start Subscription' : 'Manage Billing';

  return (
    <div className={className}>
      <Button onClick={handleClick} disabled={isLoading} className="min-w-[200px]">
        {isLoading ? (
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        ) : (
          <CreditCard className="mr-2 h-4 w-4" />
        )}
        {label}
      </Button>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
}
